export const defaultPartnerAlias = 'kampanje';

export const defaultDwellingUnit = 'bolig';
